<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>

<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item custom">
    <h1>ფოტოდან სურნელს იგრძნობ ანუ გაიცანი კაფე „დაფნა“</h1>
    <h6>დეკემბერი 2023</h6>
    <br />

    <img src="../../../../assets/blog/dafna/img1.jpg" alt="" />

    <p>
      ცნობილი გამონათქვამის მიხედვით, ქართველების მეორე სისხლი - ღვინოა, მესამე - ტყემალი. ჩვენი კვებითი თავისებურებები,
      ჩვევები, ტრადიციები და თვითონ კერძებიც კი, იმდენად ბუნებრივად არის შერწყმული ქვეყნის იდენტობასთან, რომ სტუმრის
      მასპინძლობა თუ ეროვნული სამზარეულო ხელოვნების დონეზე გვაქვს აყვანილი. ამ შემთხვევაში, მოდერნისტული
      გადაწყვეტილებები დიდ სითამამეს მოითხოვს, სწორედ ამიტომ, გიყვებით კაფე „დაფნაზე“ რომელიც არტიზანულ ხინკალს
      სთავაზობს ვიზიტორებს.
    </p>

    <p>
      უმაღლესი რეიტინგი OTA ტურისტულ გზამკვლევებში ხმამაღლა ამბობს სათქმელს. ეს ნამდვილად არის ის გამორჩეული სივრცე ძველ
      თბილისში, რომლის ხარისხზეც ადგილობრივი თუ უცხოელი სტუმრები თანხმდებიან.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/dafna/img2.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        თავდაპირველად ვერც წარმოვიდგენდით, რომ ობიექტს, რომელშიც მართლა მთელი სული და გული ჩავდეთ ყველა ასე შეიყვარებდა.
      </b>
    </p>

    <p>
      „დაფნაში“ ინტერიერი, მენიუ, სერვირება, ყველაფერი მინიმალისტურია, რადგან მთავარი აქცენტი კერძების გემოვნურ
      თვისებებსა და მომსახურების ხარისხზე კეთდება.
    </p>

    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        ხინკალი თავისთავად იმდენად დახვეწილი საკვებია ჩემთვის, ისევე როგორც ნებისმიერი ქართველისთვის, რომ არ სჭირდება
        რაიმეს დამატება. ჩვენ ვცდილობთ არტიზანული მიდგომით მაქსიმალურად შევუნარჩუნოთ მას ტრადიციული გემო
      </b>
    </p>

    <p>
      2022 წელს ფორბსის „The 12 Best Georgian Restaurants In Tbilisi“ -ის სიაში მოხვედრილი ლოკაცია სხვადასხვა საინტერესო
      კერძს სთავაზობს სტუმრებს. ქართული სამზარეულოს ახლებური ინტერპრეტაცია და საავტორო კერძები რომ მათ მაგიდაზე მოხვდეს,
      კომპანიას შესაბამისი სამზარეულო დანადგარები სჭირდება, რომელთა ნაწილიც თიბისი ლიზინგით დაიფინანსეს.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/dafna/img3.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'"
        >სამომავლო გეგმებზე საუბრისგან ახლა თავს შევიკავებ, თუმცა პირობას ვდებთ, რომ ქართველი თუ უცხოელი ვიზიტორებისთვის
        ერთ-ერთი საყვარელი ლოკაცია, კაფე „დაფნა“ მაქსიმალურს გააკეთებს იმისთვის, რომ ეს სტატუსი ღირსეულად შეინარჩუნოს.
      </b>
    </p>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item custom">
    <h1>You Can Smell the Aroma from the Photo – Get to know the Café „Dafna“</h1>
    <h6>December 2023</h6>
    <br />

    <img src="../../../../assets/blog/dafna/img1.jpg" alt="" />

    <p>
      According to a famous saying, the second blood of Georgians is wine, the third is tkemali. Our culinary
      peculiarities, habits, traditions, and even the dishes themselves are so naturally intertwined with the country's
      identity that hospitality for guests and national cuisine are elevated to an art form. In this case, modernist
      solutions require a lot of boldness, which is why I am telling you about Café "Dafna," which offers artisan
      khinkali to its visitors.
    </p>

    <p>
      The highest rating in OTA tourist guides loudly speaks for itself. This is truly the distinctive space in Old
      Tbilisi, the quality of which is agreed upon by both local and foreign visitors.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/dafna/img2.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        At first, we couldn’t even imagine that the place we poured our whole soul and heart into would be loved by
        everyone this much.
      </b>
    </p>

    <p>
      In "Dafna," the interior, the menu, the service, everything is minimalist because the main focus is placed on the
      taste qualities of the dishes and the quality of service.
    </p>

    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        Khinkali is such a refined dish for me, just as it is for every Georgian, that it doesn't require anything
        extra. We strive to preserve its traditional taste as much as possible with an artisan approach.
      </b>
    </p>

    <p>
      The location, which made it onto Forbes' list of "The 12 Best Georgian Restaurants in Tbilisi" in 2022, offers
      guests a variety of interesting dishes. For the new interpretation of Georgian cuisine and signature dishes to
      land on their tables, the company needed the appropriate kitchen equipment, part of which was financed through TBC
      Leasing.
    </p>
  </div>

  <div class="container-fluid m-0 p-0">
    <div class="full-color background-light-blue p-0">
      <div class="container p-0">
        <img class="p-0" src="../../../../assets/blog/dafna/img3.jpg" alt="" />
      </div>
    </div>
  </div>

  <div class="container blog-item custom">
    <p class="quote-sign light-blue">“</p>

    <p>
      <b style="font-size: 26px; font-family: 'TBCX-BOLD'">
        I will refrain from talking about future plans for now, but we promise that Café "Dafna," one of the favorite
        locations for both Georgian and foreign visitors, will do its utmost to maintain this status with dignity.
      </b>
    </p>
  </div>
</ng-container>
